if (!customElements.get("announcement-swiper")) {
  customElements.define(
    "announcement-swiper",
    class AnnouncementSwiper extends HTMLElement {
      async connectedCallback() {
        if (this.swiper) return;

        const container = this.querySelector(
          "[data-announcement-swiper-container]",
        );
        if (!container) return;

        const slides = this.querySelectorAll(
          "[data-announcement-swiper-slide]",
        );
        if (slides.length < 2) return;

        const { default: Swiper } = await import(
          "./swiper-bundle.esm.browser.min.js"
        );

        this.swiper = new Swiper(container, {
          effect: "fade",
          fadeEffect: { crossFade: true },
          slidesPerView: 1,
          speed: 600,
          loop: true,
          autoplay: {
            delay: 4000,
            disableOnInteraction: false,
          },
        });

        this.addEventListener("shopify:block:select", (event) => {
          const slide = this.querySelector(
            `[data-block-id="${event.detail.blockId}"]`,
          );
          if (!slide) return;
          const index = Array.from(slide.parentNode.children).indexOf(slide);
          this.swiper.autoplay.stop();
          this.swiper.slideToLoop(index);
        });

        this.addEventListener("shopify:block:deselect", () => {
          this.swiper.autoplay.start();
        });
      }

      disconnectedCallback() {
        this.swiper?.destroy();
        this.swiper = null;
      }
    },
  );
}
